import { render, staticRenderFns } from "./MoreDetailsStep.vue?vue&type=template&id=2477738d&"
import script from "./MoreDetailsStep.vue?vue&type=script&lang=js&"
export * from "./MoreDetailsStep.vue?vue&type=script&lang=js&"
import style0 from "./MoreDetailsStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContactStepHeader: require('/opt/build/repo/components/contact/StepHeader.vue').default})
